import { request } from "@/utils/request";

export const getStepModel = (params) => {
  return request.get("/api/bom/products/getStepModel", params);
};

export const getBomBySelection = (data) => {
  return request.post("/api/bom/products/getBomBySelection", data);
};

export const getGoodsDetail = (id) => {
  return request.get(`/api/bom/products/getProductDetailsById/${id}`);
};

export const getAddressListApi = () => {
  return request.get("/api/receiveAddress/listQuery");
};

export const submitOrderApi = (data) => {
  return request.post("/api/shop/purchase/submit", data);
};

export const payApi = (data) => {
  return request.post("/api/order/payment", data);
};
